import script from "./slideProductSix.vue?vue&type=script&setup=true&lang=js"
export * from "./slideProductSix.vue?vue&type=script&setup=true&lang=js"

import "./slideProductSix.vue?vue&type=style&index=0&id=a3bf3f3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3bf3f3e"]])

export default __exports__